<template>
    <div class="shop-wrapper">
        <div id="orders-list" class="section">
            <!-- Container -->
            <div class="container">

                <div class="section no-padding">
                    <div class="checkout-wrapper">

                        <!--Success step-->
                        <div class="checkout-main">
                            <div class="checkout-container">
                                <div class="checkout-success">
                                    <div class="success-card">
                                        <div class="success-content has-text-centered">
                                            <svg class="SuccessAnimation is-primary animated" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">
                                                <path class="SuccessAnimationResult" fill="#D8D8D8" d="M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z"></path>
                                                <circle class="SuccessAnimationCircle" cx="35" cy="35" r="24" stroke="#979797" stroke-width="2" stroke-linecap="round" fill="transparent"></circle>
                                                <polyline class="SuccessAnimationCheck" stroke="#979797" stroke-width="2" points="23 34 34 43 47 27" fill="transparent"></polyline>
                                            </svg>
                                            <h3>Intención de Compra Completada!</h3>
                                            <p>Gracias por completar esta orden! Ahora que su orden esta completa, será revisada y procesada por su vendedor.</p>
                                            <div class="button-wrap">
                                                <router-link tag="button" :to="{name: 'intentions'}" 
                                                    id="end-checkout-button"
                                                    class="button primary-button raised is-fullwidth is-rounded">
                                                    <span>Intenciones de Compra</span>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <!-- /Container -->
        </div>   
    </div>   
</template>

<script>

export default {
    name: 'cart-checkout',
}
</script>

<style>
.table-container{
    width: 100%;
    padding: 30px;
}
.table-wrapper{
    overflow-x: auto;
}
.checkout-wrapper .checkout-main {
    flex: auto !important;
}
.checkout-wrapper .checkout-main .checkout-container .checkout-success .success-card .success-content .button-wrap .button{
    max-width: 250px !important;
}
</style>

        